import { LogLevel } from '@azure/msal-browser';

const tenantName = 'remaxnovaapp';

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: 'B2C_1_SignUpSignIn',
        resetPassword: 'B2C_1_PasswordReset',
    },
    authorities: {
        signUpSignIn: {
            authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/B2C_1_SignUpSignIn`,
        },
        resetPassword: {
            authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/B2C_1_PasswordReset`,
        },
    },
    authorityDomain: `${tenantName}.b2clogin.com`,
};

// export const b2cPolicies = {
//     names: {
//         signUpSignIn: 'B2C_1A_SeamlessMigration_signuporsignin',
//         resetPassword: 'B2C_1_PasswordReset',
//     },
//     authorities: {
//         signUpSignIn: {
//             authority: 'https://mapdev2.b2clogin.com/mapdev2.onmicrosoft.com/B2C_1A_SeamlessMigration_signuporsignin',
//             // authority: 'https://mapdev2.b2clogin.com/mapdev2.onmicrosoft.com/B2C_1A_signup_signin',
//             // authority: 'https://mapdev2.b2clogin.com/mapdev2.onmicrosoft.com/B2C_1_SignUpSignIn',
//         },
//         resetPassword: {
//             authority: 'https://mapdev2.b2clogin.com/mapdev2.onmicrosoft.com/B2C_1_PasswordReset',
//         },
//     },
//     authorityDomain: 'mapdev2.b2clogin.com',
// };

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 * For more details on using MSAL.js with Azure AD B2C, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/working-with-b2c.md
 */

export const msalConfig = {
    auth: {
        clientId: '8dfbbc0c-9215-41a4-87fa-6234672e83c1', // remaxnova SPA app in renamxnova tenent
        // clientId: 'b15e76c3-872f-4373-b254-25af490267bb', // registered as remaxtester in mapdev2 tenent
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: process.env.VUE_APP_REDIRECT_URI, // You must register this URI on Azure Portal/App Registration. Defaults to "window.location.href".
    },
    cache: {
        cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // If you wish to store cache items in cookies as well as browser cache, set this to "true".
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
        },
    },
};

export const scopes = [
    `https://${tenantName}.onmicrosoft.com/f81693a0-5ce4-41e4-8857-144cee04b975/access_as_user`,
    // `https://${tenantName}.onmicrosoft.com/b15e76c3-872f-4373-b254-25af490267bb/access_as_user`,
];

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ['openid', ...scopes],
};

/**
 * Scopes you add here will be used to request a token from Azure AD B2C to be used for accessing a protected resource.
 * To learn more about how to work with scopes and resources, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const tokenRequest = {
    scopes: [...scopes],
    forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};

export const buildResetRoute = () => {
    const url = new URL(`https://${b2cPolicies.authorityDomain}/${tenantName}.onmicrosoft.com/oauth2/v2.0/authorize`);
    url.searchParams.append('p', b2cPolicies.names.resetPassword.toUpperCase());
    url.searchParams.append('client_id', msalConfig.auth.clientId);
    url.searchParams.append('nonce', 'defaultNonce');
    url.searchParams.append('redirect_uri', msalConfig.auth.redirectUri);
    url.searchParams.append('scope', 'openid');
    url.searchParams.append('response_type', 'id_token');
    url.searchParams.append('prompt', 'login');
    return url.href;
};
